interface Props {
  className?: string
  faction?: string | null
  fileName?: string
  size: 'custom' | 'small' | 'large'
}

const BannerImage = ({ className, faction, fileName, size }: Props) => {
  return (
    <figure
      className={`${className} ${
        size === 'custom'
          ? ''
          : size === 'small'
          ? 'w-10 h-10 min-w-10 min-h-10'
          : 'w-28 h-28 min-w-28 min-h-28'
      } bg-cover`}
      style={{
        backgroundImage: `url(https://data.wowaudit.com/crests/${
          fileName ?? `default-${(faction ?? 'Alliance').toLowerCase()}.png`
        })`,
      }}
    />
  )
}

export default BannerImage
